import {SysConfigBaseApi} from "./SysConfigBaseApi";
/**
 * File Api
 */
export class FileApi extends SysConfigBaseApi {
    public get ControllerName(): any {
        return 'File'
    }
    GetFiles(token) {
        token = token==null || token=="" || token==undefined?0:token
        return this.send({}, "GetFiles?Token=" + token, this.Methods.POST);
    } 
    /**
     * 获取文件路径
     * @param token 
     * @param id 
     * @returns 
     */
    getFileUrl(token, id) {
        return this.getUrl("Get") + "?tokenId=" + token + "_" + id;
    } 
    /**
     * 获取文件
     * @param tokenId 
     * @returns 
     */
    public Get(tokenId, fileName) {
        return this.sendDownload({ tokenId }, "Get", this.Methods.GET, fileName);
    }

    /**
     * 获取文件内容
     * @param tokenId 
     * @returns 
     */
    public GetBase64(tokenId) {
        return this.send({tokenId}, 'GetBase64', this.Methods.GET);
    }

    /**
     * 删除单个文件
     * @param tokenId 
     */
    public DeleteByTokenId(tokenId: string) {
        return this.send({}, "Delete?TokenId=" + tokenId, this.Methods.POST);
    }

    /**
     * 删除附件通过Token
     * @param token 
     */
    public DeleteByToken(token) {
        return this.send({}, "DeleteByToken?token=" + token, this.Methods.POST);
    }

    /**
     * 读取文本
     * @param token 
     */
    public ReadText(token: string) {
        return this.send({ token }, "ReadText", this.Methods.GET);
    }

    /**
     * 写入文本
     * @param projectSKey 
     * @param catalogPath 
     * @param data 
     * @param token 
     */
    public WriteText(projectSKey: string, catalogPath: string, data: string, token: string = '') {
        return this.send({ ProjectSKey: projectSKey, CatalogPath: catalogPath, Token: token, Data: data }, "WriteText", this.Methods.POST, "Upload");
    }
    public DownloadFile(fileName) {
        return this.getUrl("DownloadFile", this.ControllerName) + '?fileName='+fileName;
        //  return this.send({ fileName: fileName }, "DownloadFile", this.Methods.GET)
    }
}
